import React from 'react';
import { formatToCompactNumber } from '~/libs/utils/format/number';

export interface DddShareBarProps {
	ddd: number;
	/** Share of the ATC/RS group, expressed as a fraction (0-1). */
	dddShare: number;
	dddShareThreshold: number;
}

export function DddShareBar({ ddd, dddShare, dddShareThreshold }: DddShareBarProps) {
	const isAboveThreshold = dddShare * 100 > dddShareThreshold;

	return (
		<>
			<div className='flex justify-between items-center w-full text-label text-gray-900 leading-5 uppercase tabular-nums'>
				<span>DDD:</span>
				<strong className='font-bold pr-1.5'>{formatToCompactNumber(ddd, 2)}</strong>
			</div>
			<div
				className={`relative w-full h-6 leading-6 rounded overflow-hidden ${
					isAboveThreshold ? 'bg-gray-900 text-white' : 'bg-gray-300 text-gray-900'
				}`}
			>
				<i
					className={`absolute left-0 top-0 h-full min-w-1.5 rounded ${
						isAboveThreshold ? 'bg-cBlue-500' : 'bg-gray-400'
					}`}
					style={{ width: `${(dddShare * 100).toFixed(2)}%` }}
				></i>
				<span className='absolute left-0 top-0 w-full h-6 leading-6 px-1.5 text-label font-semibold tabular-nums uppercase text-right'>
					{formatToCompactNumber(dddShare * 100)} %
				</span>
			</div>
		</>
	);
}
